export default {"src":"https://fishbrain.com/_next/static/media/ic_weather_night_335.b6a986cd.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};